/**
 * Anzeige für die Felder aus `TicketRow`, die absichtlich maskiert sein
 * können — Tor 1 des Loops für 006a nennt sie ausdrücklich:
 * `TicketSubject.label`/`.kind`, `TicketCostCenter.label` sind `null`, wenn
 * der zugehörige Datensatz für den Leser selbst nicht sichtbar ist (ein
 * Grant direkt auf die Aufgabe macht sie sichtbar, ohne dass Objekt oder
 * Kostenstelle es werden), `TicketAssignee.display_name` ist `null` für
 * einen externen Aufrufer („extern entdeckt nichts", Spec 05a). Keiner
 * dieser Fälle ist ein Fehler im Vertrag — diese Funktionen zeigen dafür
 * einen neutralen Platzhalter statt einer leeren Zelle oder eines Absturzes.
 */

import type { TicketAssignee, TicketCostCenter, TicketSubject } from './api'

/**
 * `label` zuerst, sonst `path_label` (der Pfad bleibt oft lesbar, auch wenn
 * das Objekt selbst nicht benannt werden darf — ein unsichtbarer Vorfahr
 * wird darin bereits zu `""`, `shared/hierarchy.py::path_label_expr`), sonst
 * der Platzhalter.
 */
export function subjectLabel(subject: TicketSubject): string {
  if (subject.label !== null) return subject.label
  if (subject.path_label !== '') return subject.path_label
  return 'Objekt ohne Namen'
}

export function assigneeLabel(assignee: TicketAssignee | null): string | null {
  if (assignee === null) return null
  return assignee.display_name ?? 'Person ohne Namen'
}

export function costCenterLabel(costCenter: TicketCostCenter | null): string | null {
  if (costCenter === null) return null
  return costCenter.label ?? 'Kostenstelle ohne Namen'
}
